import React from 'react';
import { Navbar } from '../components/landing/Navbar';
import { Hero } from '../components/landing/Hero';
import { Problem } from '../components/landing/Problem';
import { Solution } from '../components/landing/Solution';
import { CaseStudy } from '../components/landing/CaseStudy';
import { Features } from '../components/landing/Features';
import { ForResorts } from '../components/landing/ForResorts';
import { ForAgencies } from '../components/landing/ForAgencies';
import { AgencySignup } from '../components/landing/AgencySignup';
import { BusinessModel } from '../components/landing/BusinessModel';
import { AICapabilities } from '../components/landing/AICapabilities';
import { Roadmap } from '../components/landing/Roadmap';
import { CTASection } from '../components/landing/CTASection';
import { Footer } from '../components/landing/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-stone-50 font-sans text-stone-900" data-id="element-2029">
      <Navbar data-id="element-2030" />
      <main data-id="element-2031">
        <Hero data-id="element-2032" />
        <Problem data-id="element-2033" />
        <Solution data-id="element-2034" />
        <CaseStudy data-id="element-2035" />
        <Features data-id="element-2036" />
        <ForResorts data-id="element-2037" />
        <ForAgencies data-id="element-2038" />
        <AgencySignup data-id="element-2039" />
        <BusinessModel data-id="element-2040" />
        <AICapabilities data-id="element-2041" />
        <Roadmap data-id="element-2042" />
        <CTASection data-id="element-2043" />
      </main>
      <Footer data-id="element-2044" />
    </div>;
}